import { forwardRef } from "react";
import PropTypes from "prop-types";
import InputAdornment from "@mui/material/InputAdornment";
import GrIcon from "./GrIcon";
import icons from "../icons";
import GrTextField from "./GrTextField";
import GrIconButton from "./GrIconButton";

// Search field: leading icon, clear button when there is text. Controlled: pass value + onChange (+ onClear).
const GrSearch = forwardRef(function GrSearch(
  {
    value = "",
    onChange,
    onClear,
    placeholder = "Search",
    label = "Search",
    sx,
    ...rest
  },
  ref
) {
  return (
    <GrTextField
      ref={ref}
      type="search"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      inputProps={{ "aria-label": label }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <GrIcon icon={icons.search} />
          </InputAdornment>
        ),
        endAdornment:
          value && onClear ? (
            <InputAdornment position="end">
              <GrIconButton
                variant="ghost"
                size="sm"
                aria-label="Clear search"
                onClick={onClear}
              >
                <GrIcon icon={icons.close} />
              </GrIconButton>
            </InputAdornment>
          ) : null,
      }}
      sx={{
        "& input[type=search]::-webkit-search-cancel-button": {
          display: "none",
        },
        ...sx,
      }}
      {...rest}
    />
  );
});

GrSearch.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  sx: PropTypes.object,
};

export default GrSearch;
